import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import type {
  BrandSummary,
  FileOwnerType,
  PageBannersSettings,
  PageCategoryProductsSettings,
} from 'types';

import { PageBuilderContent, PageBuilderHeader } from './components';

type PageBuilderLoaderData = {
  brands: BrandSummary[];
  categoryProductsSettings: PageCategoryProductsSettings;
  bannersSettings: PageBannersSettings;
};

export default function PageBuilder() {
  const data = useLoaderData() as PageBuilderLoaderData | undefined;

  const {
    brands = [],
    categoryProductsSettings = {},
    bannersSettings = {},
  } = data ?? {};

  const ownerType: FileOwnerType = 'Config';

  return (
    <React.Fragment>
      <Helmet>
        <title>صفحه اصلی | کاشی لند</title>
      </Helmet>
      <PageBuilderHeader />
      <PageBuilderContent
        ownerType={ownerType}
        brands={brands}
        categoryProductsSettings={categoryProductsSettings}
        bannersSettings={bannersSettings}
      />
    </React.Fragment>
  );
}
